import React from 'react';
import PolicyHero from '../PolicyHero';
import NewFooter from '../NewFooter';
import './blogpost.css';

const MOBILE_HERO_IMAGE = '/assets/new_assets/pst-general-banner-scaled.png';
// eslint-disable-next-line react/no-array-index-key
function renderBlock(block, i) {
  switch (block.type) {
    case 'p':
      return <p key={i} className="bp-text" dangerouslySetInnerHTML={{ __html: block.html }} />;
    case 'heading':
      return <h2 key={i} className="bp-heading">{block.text}</h2>;
    case 'quote':
      return (
        <blockquote key={i} className="bp-quote">
          <p dangerouslySetInnerHTML={{ __html: block.html }} />
        </blockquote>
      );
    case 'ul':
    case 'ol': {
      const Tag = block.type;
      return (
        <Tag key={i} className="bp-list">
          {block.items.map((item, j) => (
            <li key={j} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </Tag>
      );
    }
    default:
      return null;
  }
}

function BlogPostLayout({ title, pageName, heroImage, featuredImage, featuredImageAlt, content }) {
  return (
    <div className="bp-page">
      <PolicyHero
        title={title}
        pageName={pageName}
        heroImage={heroImage}
        bgPosition="center center"
        mobileHeroImage={MOBILE_HERO_IMAGE}
      />

      <main className="bp-article">
        <div className="bp-container">
          <div className="bp-featured">
            <img src={featuredImage} alt={featuredImageAlt || ''} className="bp-featured__img" />
          </div>

          {content.map(renderBlock)}
        </div>
      </main>

      <NewFooter />
    </div>
  );
}

export default BlogPostLayout;
